import { ReactNode } from "react";

import RadioIcon from "../../Radio/Icon";

type TileIndicatorProps = {
  indicator: "radio" | ReactNode;
  selected?: boolean;
  disabled?: boolean;
};

const TileIndicator = ({ indicator, selected, disabled }: TileIndicatorProps) => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (indicator) {
    case "radio":
      return <RadioIcon checked={selected} disabled={disabled} />;
    default:
      return <>{indicator}</>;
  }
};

TileIndicator.displayName = "DS.Tile.Indicator";

export default TileIndicator;
